export default function nameToId(name) {
  return name.toLowerCase().replaceAll(' ', '_')
}

